// third-party
import { FormattedMessage } from "react-intl";

// assets
import { Personalcard } from "iconsax-react";

// type
import { NavItemType } from "types/menu";

// icons
const icons = {
  userList: Personalcard,
};

// ==============================|| MENU ITEMS - WIDGETS ||============================== //

const userList: NavItemType = {
  id: "group-users-list",
  title: <FormattedMessage id="page.menu_items_all_user_label" />,
  icon: icons.userList,
  type: "group",
  children: [
    {
      id: "user-list",
      title: <FormattedMessage id="page.menu_items_all_user_label" />,
      type: "item",
      url: "/all-users",
      icon: icons.userList,
    },
  ],
};

export default userList;
